import type { Fallacy } from "./types";
import { createStory } from "./types";

export const dunningKruger: Fallacy = {
    id: "dunning-kruger",
    name: "Dunning-Kruger Effect",
    emoji: "🤓",
    category: "Otak yang Menipu Diri",
    description: "Orang yang **tahu sedikit** merasa **paling ahli**, sementara yang ahli justru meragukan dirinya.",
    tldr: "Baru belajar 5 menit udah merasa jago? Klasik Dunning-Kruger.",
    detail: "Dunning-Kruger Effect adalah bias kognitif di mana orang berpengetahuan rendah **melebih-lebihkan kompetensinya**, sementara yang kompeten justru meremehkan kemampuannya. Ditemukan oleh Dunning dan Kruger (1999), akarnya adalah **ketidakmampuan mengenali ketidakmampuan sendiri**.\n\nDi media sosial, efek ini sangat terlihat. Orang dengan pemahaman dangkal sering paling vokal, sementara ahli sejati lebih hati-hati karena paham kompleksitas topik.\n\nGrafik klasiknya: kepercayaan diri memuncak di awal (Mount Stupid), anjlok saat sadar banyak yang belum diketahui (Valley of Despair), lalu naik perlahan seiring kompetensi.\n\nCara melawan: Selalu tanya, \"Apa yang belum gue tahu tentang topik ini?\"",
    story: createStory("Dunning-Kruger Effect", "🤓", {
      hook: {
        title: "Baru belajar sesuatu 5 menit...",
        body: "Udah ngerasa jago? Tenang, kamu gak sendirian. Dan itu masalahnya.",
      },
      convo: {
        claim: "Aku baru belajar Python 2 minggu dari YouTube dan udah bisa bikin kalkulator. **Coding tuh gampang banget**, software engineer overpaid sih menurut aku.",
        response: "Kamu belum ketemu bug production jam 2 pagi. **2 minggu bukan 2 tahun.**",
      },
      reveal: {
        body: "Yang **tahu sedikit** justru ngerasa **paling jago**. Sementara yang beneran ahli malah lebih hati-hati karena paham betapa kompleksnya suatu topik.",
      },
      insight: {
        title: "Ada grafiknya loh",
        body: "Kepercayaan diri **memuncak di awal** (Mount Stupid), anjlok pas sadar banyak yang belum diketahui, baru naik perlahan seiring beneran kompeten.",
      },
      engagement: {
        title: "Bidang apa yang bikin kamu ngerasa \"ternyata susah\"?",
        body: "Coding, investasi, atau masak? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "hasty-generalization", "bandwagon"],
  };
